module.exports = __webpack_public_path__ + "img/lijiruzhu_en.fe7db6a9.jpg";